import React from "react";
import ReactDOM from "react-dom/client";
import Themes from "./themes";
import App from "./components/App";
import { LayoutProvider } from "./context/LayoutContext";
import { UserProvider } from "./context/UserContext";
import { StoreProvider } from "./context/StoreContext";
import "./template-card.css";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <StyledEngineProvider injectFirst>
    <LayoutProvider>
      <UserProvider>
        <StoreProvider>
          <ThemeProvider theme={Themes.default}>
            <CssBaseline />
            <App />
          </ThemeProvider>
        </StoreProvider>
      </UserProvider>
    </LayoutProvider>
  </StyledEngineProvider>,
);
